import { useContext, useEffect, useRef, useState } from 'react';
import { FormUtility } from '../../../Utility/FormUtility';
import Input from '../../../Form/Input';
import Select from '../../../Form/Select';
import { useNavigate, useParams } from 'react-router-dom';
import { Comune } from '../../../../models/Comune';
import { ComuneService } from '../../../../services/ComuneService';
import ToastContext from '../../../../contexts/toast';
import StatusContext from '../../../../contexts/status';
import { tipologiaUtente } from '../../../../constants/TipologiaUtente';

export default function GestioneAnagraficaComune() {
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);

  const [startup, setStartup] = useState(false);

  const [inSave, setInSave] = useState(false);

  const [comuni, setComuni] = useState(null);
  const [comuniDaAssociare, setComuniDaAssociare] = useState(null);
  const [capofila, setCapofila] = useState(null);

  const [comuniAssociati, setComuniAssociati] = useState([]);

  const tipologie = [
    { key: 'Unione di Comuni' },
    { key: 'Gestione Associata' },
  ];

  const [ente, setEnte] = useState(new Comune());

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const comuneService = new ComuneService();
  const utility = new FormUtility();

  const params = useParams();
  const navigation = useNavigate();
  const formRef = useRef(null);

  const enteId = params.id ? parseInt(params.id) : null;

  useEffect(() => {
    comuneService.getAllByTipologiaAndDenominazioneRegione('Comune', 'Toscana', 'noDismessi').then((resp) => {
      resp.sort((a, b) => a.denominazione.localeCompare(b.denominazione));
      setComuni(!comuni ? [ ...resp ] : comuni);
      setComuniDaAssociare(!comuniDaAssociare ? [ ...resp ] : comuniDaAssociare);
    });

    if (enteId) {
      comuneService.getById(enteId).then(resp => {
        setEnte({ ...resp });
        setCapofila(resp.capofila);
      }).catch(error => {
        console.log(error);
      });
    }

    return () => {
      statusContext.removeEvent('onbeforeunload');
    }
  }, []);

  useEffect(() => {
    if (
      enteId &&
      !startup &&
      !!capofila &&
      !!comuni &&
      !!comuniDaAssociare &&
      Object.keys(ente).length > 0
    ) {
      setStartup(true);

      const muniAssociated = ente.comuniAssociati.filter(
        (c) => !c.isCapofila
      );
      setComuniAssociati([...muniAssociated]);
      setComuniDaAssociare([
        ...comuniDaAssociare.filter(
          (c) =>
            !c.isCapofila && !muniAssociated.map((m) => m.id).includes(c.id)
        ),
      ]);
    }
  }, [startup, comuni, comuniDaAssociare, capofila, ente]);

  const onChangeValue = async (event) => {
    const target = event.target;
    ente[target.name] = target.value;
    setEnte({ ...ente });

    statusContext.addEvent('onbeforeunload');

    if (validate) {
      setFormErrors(false);
    }
  };

  const onChangeCapofila = (event) => {
    const comuneId = parseInt(event.target.value);
    const capo = comuni.find(c => c.id === comuneId);

    toastContext.clear();

    if (capofila) {
      comuniDaAssociare.push(capofila);
    }

    if (capo) {
      let toastMsg = '';
      if (capo?.ente && ente?.id !== capo.ente?.id) {
        toastMsg += 'Il comune capofila fa già parte di un ente';
      }
      if (toastMsg) {
        toastContext.error(toastMsg, 12000, 100);
      }

      const index = comuniDaAssociare
        .map((m) => m.id)
        .indexOf(parseInt(comuneId));
      comuniDaAssociare.splice(index, 1);
    }

    setCapofila(capo);

    setComuniDaAssociare([ ...comuniDaAssociare.sort((a, b) => a.denominazione.localeCompare(b.denominazione)) ]);

    statusContext.addEvent('onbeforeunload');
    if (validate) {
      setFormErrors(false);
    }
  };

  const onChangeComuneAssociato = (event) => {
    const comuneId = parseInt(event.target.value);
    const muni = comuniDaAssociare.find((c) => c.id === comuneId);

    toastContext.clear();

    if (muni) {
      let toastMsg = '';
      if (muni.utentiOpRef?.filter(c => c.tipologia === tipologiaUtente.referenteComunale).length > 0) {
        toastMsg = 'Non è possibile selezionare il comune avendo già un referente associato\n';
      }
      if (muni.ente?.id && muni.ente.id !== ente?.id) {
        toastMsg += 'Il comune fa già parte di un ente';
      }
      if (toastMsg) {
        toastContext.error(toastMsg, 12000, 100);
      }
    }

    comuniAssociati.push(muni);
    setComuniAssociati([ ...comuniAssociati.sort((a, b) => a.denominazione.localeCompare(b.denominazione)) ]);

    const index = comuniDaAssociare
      .map((m) => m.id)
      .indexOf(parseInt(comuneId));
    comuniDaAssociare.splice(index, 1);
    setComuniDaAssociare([ ...comuniDaAssociare ]);

    const indexCapofila = comuni
      .map((m) => m.id)
      .indexOf(parseInt(comuneId));
    comuni.splice(indexCapofila, 1);
    setComuni([ ...comuni ]);

    statusContext.addEvent('onbeforeunload');
    if (validate) {
      setFormErrors(false);
    }
  };

  const rimuoviComuneAssociato = (comune) => {
    const index = comuniAssociati.map((m) => m.id).indexOf(parseInt(comune.id));
    comuniAssociati.splice(index, 1);
    setComuniAssociati([...comuniAssociati]);

    comuniDaAssociare.push(comune);
    setComuniDaAssociare([ ...comuniDaAssociare.sort((a, b) => a.denominazione.localeCompare(b.denominazione)) ]);

    comuni.push(comune);
    setComuni([ ...comuni.sort((a, b) => a.denominazione.localeCompare(b.denominazione)) ]);

    statusContext.addEvent('onbeforeunload');
    if (validate) {
      setFormErrors(false);
    }
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const denyOperation = () => {
    navigation('/gestione-adesione-enti');
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    let toastMsg = '';
    if (capofila?.ente && ente?.id !== capofila.ente?.id) {
      toastMsg += 'Il comune capofila fa già parte di un ente';
    }
    if (comuniAssociati.find(ca => ca.utentiOpRef?.filter(c => c.tipologia === tipologiaUtente.referenteComunale).length > 0)) {
      toastMsg = 'Uno o più comuni associati presenta già un referente associato\n';
    }
    if (comuniAssociati.find(ca => ca.ente?.id && ca.ente.id !== ente.id)) {
      toastMsg = 'Uno o più comuni associati fanno già parte di un ente';
    }
    if (toastMsg) {
      toastContext.error(toastMsg, 10000);
      return;
    }

    setInSave(true);

    setInputErrors([]);

    ente.dataInizioValidita = '1900-01-01';
    ente.comuniAssociati = comuniAssociati;
    ente.capofila = capofila;
    ente.denominazioneRegione = 'Toscana';

    const service = enteId ? comuneService.update : comuneService.create;
    service(ente)
      .then(() => {
        toastContext.success('Ente ' + (enteId ? 'aggiornato' : 'aggiunto') + ' con successo!');
        statusContext.removeEvent('onbeforeunload');

        setTimeout(() => {
          navigation('/gestione-adesione-enti');
        }, 100);

        setInSave(false);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setInSave(false);
      });
  };

  return (
    <div className='rtds-container rtds-my-12 '>
      <div className='rtds-mb-6 '>
        <h1 className='rtds-text-2xl rtds-font-bold'>{enteId ? 'Modifica Ente' : 'Inserimento Ente'}</h1>
      </div>
      <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
        <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className='rtds-font-bold rtds-no-underline'
              title='obbligatorio'
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id='hasValidationForm'
          className='has-js-validation-form rtds-py-6 rtds-space-y-4'
          onSubmit={sendData}
        >
          <Select
            classDiv={'rtds-mt-3 lg:rtds-mt-0'}
            label={'Tipologia'}
            required
            id={'tipologia'}
            inputErrors={inputErrors}
            classSelect={''}
            onChange={(event) => onChangeValue(event)}
            baseOption={'Seleziona Tipologia'}
            options={tipologie}
            bindValue={'key'}
            value={ente.tipologia || ''}
          />

          <Input
            label={'Denominazione'}
            required
            id={'denominazione'}
            inputErrors={inputErrors}
            classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
            type={'text'}
            onChange={(event) => onChangeValue(event)}
            value={ente.denominazione || ''}
            maxLength={100}
          />

          {
            ente.tipologia && 
            <>
              <Select
                classDiv={'rtds-mt-3 lg:rtds-mt-0'}
                label={'Comune Capofila'}
                required
                id={'capofila'}
                inputErrors={inputErrors}
                onChange={(event) => onChangeCapofila(event)}
                baseOption={'Seleziona Comune Capofila'}
                options={comuni}
                bindKey={'id'}
                bindValue={'denominazione'}
                value={capofila?.id || ''}
              />

              <h2 id='comuniAssociatiTitle' className='rtds-input-field__label'>
                Comuni Associati *
              </h2>
              <ul aria-labelledby='comuniAssociatiTitle' className='sx-mt-1'>
                {
                  comuniAssociati.map((opt) => (
                    <li key={opt.id} className='rtds-mb-3 rtds-aling-center rtds-flex'>
                      <button
                        type='button'
                        className='rtds-btn rtds-btn--icon rtds-btn--secondary rtds-btn--s'
                        onClick={() => rimuoviComuneAssociato(opt)}
                        title='Premi per rimuovere comune da elenco'
                      >
                        <svg
                          className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4'
                          aria-hidden='true'
                          focusable='false'
                          role='img'
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--minus`}
                          />
                        </svg>
                        <span className='rtds-sr-only'>Rimuovi comune da elenco</span>
                      </button>
                      &nbsp;{opt.denominazione}
                    </li>
                  ))
                }
              </ul>
              <Select
                classDiv={'sx-mt-0 lg:rtds-mt-0'}
                classLabel={'rtds-sr-only'}
                required={comuniAssociati.length === 0}
                id={'comuneDaAssociare'}
                inputErrors={inputErrors}
                onChange={(event) => onChangeComuneAssociato(event)}
                baseOption={'Seleziona comuni da associare'}
                options={comuniDaAssociare}
                bindKey={'id'}
                bindValue={'denominazione'}
                value={ente.comuneDaAssociare || ''}
                errorMessage={'Selezionare almeno un comune'}
              />
            </>
          }

          <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
            <div className='rtds-form-actions'>
              <div
                className='rtds-inline-flex rtds-gap-1'
                role='group'
                aria-label='Azioni'
              >
                <button
                  type='button'
                  className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  onClick={() => denyOperation()}
                  disabled={inSave}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6  group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>
                  Annulla
                </button>
                <button
                  type='submit'
                  className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  disabled={inSave || !comuni?.length || !comuniDaAssociare?.length}
                >
                  
                  {enteId ? 'Salva' : 'Salva'}
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                     xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${enteId ? 'solid--chevron-right' : 'solid--chevron-right'}`}
                    />
                  </svg>
                  {/* <svg
                    className='rtds-icon rtds-fill-current rtds-w-12 rtds-h-12 rtds-animate-spin'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                    hidden={inSave}
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                    />
                  </svg> */}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
